import clsx from "clsx";

/**
 * The value used to indent sub lists in OrderedList.
 * @param multiplier
 * @returns A value that can be used as a className to indent an element.
 */
export function ListIndent(multiplier?: number) {
  return `ml-[${28 * (multiplier ?? 1)}px]`;
}

export const OrderedList = ({
  variant: listStyleType = "decimal",
  children,
  className,
  indent = 0,
}: {
  variant?: "decimal" | "upper-alpha" | "disc";
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  indent?: number;
}) => {
  const nodes = Array.isArray(children) ? children : Array.of(children);
  return (
    <ol
      style={{ listStyleType }}
      className={clsx(
        "list-inside m-0 space-y-2",
        {
          [ListIndent(indent)]: indent,
          "mt-2": indent > 0,
          "marker:text-xxs": listStyleType === "disc",
        },
        className,
      )}
    >
      {nodes.map((child, index) => (
        <li key={index}>
          <i className="ml-2" />
          {child}
        </li>
      ))}
    </ol>
  );
};
